import { Ninetailed } from '@ninetailed/experience.js';

import { NINETAILED_ALLOWED_EVENTS } from './analytics/constants/analytics-events';
import { Config } from './config';
import { isBrowser } from './helpers';

type NinetailedWindow = {
  ninetailed?: {
    consent: (value: boolean) => void;
  };
};

// NinetailedClass parameter for dependency injection in tests
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ninetailedMethods = (NinetailedClass: any = Ninetailed) => {
  const ninetailed = new NinetailedClass({
    clientId: Config.GATSBY_DAVE_COM_NINETAILED_API_KEY,
    environment: Config.ENVIRONMENT,
  });

  const trackEvent = (event: string, params = {}) => {
    if (NINETAILED_ALLOWED_EVENTS.includes(event)) {
      ninetailed.track(event, params);
    }
  };

  const identify = (uid: string, traits = {}) => {
    ninetailed.identify(uid, traits);
  };

  const consent = () => {
    if (isBrowser) {
      const nt = (window as unknown as NinetailedWindow)?.ninetailed;
      if (nt && typeof nt.consent === 'function') {
        nt.consent(true);
      }
    }
  };

  return {
    trackEvent,
    identify,
    consent,
  };
};
